import { Component, effect, input, output } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { VisualDashboardDistributor } from 'dashboard/interfaces/visuals/visual-dashboard-distributor.interface';

@Component({
    selector: 'app-visuals-dashboard-distributor-picker',
    imports: [ReactiveFormsModule],
    templateUrl: './visuals-dashboard-distributor-picker.component.html',
    styleUrl: './visuals-dashboard-distributor-picker.component.scss',
})
export class VisualsDashboardDistributorPickerComponent {
    selectedOptionValue = input.required<number | null>();
    options = input.required<VisualDashboardDistributor[]>();
    distributorChange = output<number | null>();

    distributorPickerForm = new FormGroup({
        distributorControl: new FormControl<number | null>(null),
    });

    formControlValue = toSignal(this.distributorPickerForm.get('distributorControl')!.valueChanges, { initialValue: null });

    constructor() {
        effect(() => {
            const selectedOptionValue = this.selectedOptionValue();
            if (selectedOptionValue !== null) {
                this.distributorPickerForm.get('distributorControl')?.setValue(selectedOptionValue);
            } else {
                this.distributorPickerForm.get('distributorControl')?.setValue(-1);
            }
        });
        effect(() => {
            const formControlValue = this.formControlValue();
            this.distributorChange.emit(formControlValue ?? -1);
        });
    }
}
